import {
    GET_CONTACT,
    SET_CONTACT_LOADING,
    SET_CONTACT_DATA,
    GET_LOGGED_IN_CONTACT,
    REMOVE_LOGGED_IN_CONTACT,
    SET_PROPERTY_FIELDS,
    REMOVE_CONTACT_LOADING,
    SET_ENABLE_LOGIN,
    GET_ADD_CONTACT
} from "../../types";

import axios from "axios";
import { setAlert } from "../alert";
import { getApiToken } from "../../../helpers";
import { handleResponse } from "../response";
import { handleError } from "../error";
import { CanI } from "../permissions/permissions";
/**
 * @name    setCurrentUserContact
 * @returns {function(...[*]=)}
 */
export const getCurrentUserContact = () => async dispatch => {
    try {
    //	DESC: get current logged in user and set to global state
        const response = await axios.get(
            `/api/user?api_token=${getApiToken()}`
        );
        dispatch(handleResponse(response));
        dispatch({
            type: GET_LOGGED_IN_CONTACT,
            payload: response.data
        });
        return response?.data?.user_id;
    }
    catch (error) {
        console.debug({ error });
        return false;
    }
};

/**
 * @name    getContactFullNameById
 * @param   id
 * @param componentID
 * @returns {function(...[*]=)}
 */
export const getContactFullNameById = (id, { componentID }) => async(
    dispatch,
    getState
) => {
    try {
        const { properties: { propertyFields } } = getState();

        //	DESC: get contact by ID the return full name only
        //	TODO: Should we move this to MISC state ?
        const response = await axios.get(
            `/api/user/fullname?id=${id}&assetID=${componentID}&api_token=${getApiToken()}`
        );
        await dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: {
                ...propertyFields,
                net_equity_prepared_by_title: response.data.title
            }
        });

        return response.data.name;
    }
    catch (error) {
        console.debug({ error });
        return false;
    }
};

/**
 * @name    removeCurrentUserContact
 * @returns {function(...[*]=)}
 * @description
 * DESC: This method to remove current logged in contact on state. This component should only trigger when un-mount component.
 */
export const removeCurrentUserContact = () => async dispatch => {
    try {
        dispatch({ type: REMOVE_LOGGED_IN_CONTACT });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

/**
 * @name    getContact
 * @param    {*} id
 * @param verb
 */
export const getContact = (id, verb) => async dispatch => {
    try {
        dispatch({ type: SET_CONTACT_LOADING });

        const isPermitted = await dispatch(CanI("contacts_" + verb));
        if (!isPermitted) {
            window.location.href = `/contacts/`;
        }

        //	DESC: Getting single contact from backend using id
        //	DESC: ReactAPI is a temporary query to differentiate from regular view
        //	DESC: Once merge, We'll remove it
        const result = await axios.get(`/contacts/view/${id}?ReactAPI=true`);
        // Set enable_login to flag creating / deleting associated users
        result.data.contact.enable_login = result.data.contact.is_user;

        // Add default user data if none is passed
        if (!result.data.hasOwnProperty("user") || result.data.user === null) {
            result.data.user = { roles: [] };
        }

        // Map 'email' to the email fields the backend expects
        // Contact type "2" is an Organization..
        const emailField =
            result.data.contact.type === "2" ?
                "email-organization" :
                "email-individual";
        result.data.contact[emailField] = result.data.contact.email;

        await dispatch({
            type: GET_CONTACT,
            payload: result.data
        });

        //	DESC: If status not equal to 200, throw error with response text from backend
        if (result.status !== 200) {
            throw new Error(result.responseText);
        }
        dispatch({ type: REMOVE_CONTACT_LOADING });
        return {
            code: result?.data?.contact?.name,
            name: result?.data?.contact?.organization_name
        };
    }
    catch (error) {
        dispatch(handleError(error));
        return false;
    }
};

export const getAddContact = () => async dispatch => {
    try {
        dispatch({ type: SET_CONTACT_LOADING });

        //	DESC: Getting single contact from backend using id
        //	DESC: ReactAPI is a temporary query to differentiate from regular view
        //	DESC: Once merge, We'll remove it
        const result = await axios.get(`/contacts/add`);

        // Set enable_login to flag creating / deleting associated users
        result.data.contact = {
            enable_login: false,
            type: "1",
            disabled: "0",
            phone_country: "US",
            mobile_country: "US",
            fax_country: "US"
        };
        result.data.contact_contact_type = [];

        // Add default user data if none is passed
        if (!result.data.hasOwnProperty("user") || result.data.user === null) {
            result.data.user = { roles: [] };
        }

        await dispatch({
            type: GET_ADD_CONTACT,
            payload: result.data
        });

        //	DESC: If status not equal to 200, throw error with response text from backend
        if (result.status !== 200) {
            throw new Error(result.responseText);
        }
        dispatch({ type: REMOVE_CONTACT_LOADING });

        return result;
    }
    catch (error) {
        console.error(error.message);
        dispatch(setAlert(error.message, "error"));
        return false;
    }
};

/**
 * @name    updateContactData
 * @param   event
 * @param scope
 * @returns {function(...[*]=)}
 * @description
 * This Function Update global contact's fields
 * It will require a tabName if current tab needs special attention
 * Custom component will be require to mock an Event Object
 * Be sure take test custom components carefully
 */
export const updateContactData = (event, scope) => async(
    dispatch,
    getState
) => {
    try {
        const { contacts: { contactData } } = getState();

        switch (scope) {
            case "contact":
            //  DESC: update changed value on the contact object
                contactData.contact[event.target.name] = event.target.value;
                await dispatch({
                    type: SET_CONTACT_DATA,
                    payload: { ...contactData }
                });
                break;
            case "user":
            //  DESC: update changed value on the contact object
                contactData.user[event.target.name] = event.target.value;
                await dispatch({
                    type: SET_CONTACT_DATA,
                    payload: { ...contactData }
                });
                break;
            case "checkbox":
            //  DESC: update changed value on the contact object
                contactData.user[event.target.name] = event.target.checked;
                await dispatch({
                    type: SET_CONTACT_DATA,
                    payload: { ...contactData }
                });
                break;
            default:
            //  DESC: This default will update fields according to field's name and field's value
                await dispatch({
                    type: SET_CONTACT_DATA,
                    payload: {
                        ...contactData,
                        [event.target.name]: event.target.value
                    }
                });
                break;
        }
    }
    catch (error) {
        dispatch(setAlert(error.message, "warning"));
    }
};

export const setEnableLogin = isLoginEnabled => async(dispatch, getState) => {
    try {
        const { contacts: { contactData } } = getState();
        contactData.contact.enable_login = isLoginEnabled;
        dispatch({
            type: SET_ENABLE_LOGIN,
            payload: contactData
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

export const toggleDistrict = (group, isDistrictEnabled) => async(
    dispatch,
    getState
) => {
    try {
        const { contacts: { contactData } } = getState();
        contactData.associated_groups = isDistrictEnabled ?
            [...contactData.associated_groups, group.id] :
            contactData.associated_groups.filter(id => {
                return id !== group.id;
            });
        dispatch({
            type: SET_CONTACT_DATA,
            payload: contactData
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

export const toggleRole = role => async(dispatch, getState) => {
    try {
        const { contacts: { contactData } } = getState();
        contactData.user.roles = [role];
        dispatch({
            type: SET_CONTACT_DATA,
            payload: contactData
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

export const toggleType = (type, isTypeEnabled) => async(
    dispatch,
    getState
) => {
    try {
        const { contacts: { contactData } } = getState();
        contactData.contact_contact_type = isTypeEnabled ?
            [...contactData.contact_contact_type, type.id] :
            contactData.contact_contact_type.filter(type_id => {
                return type_id !== type.id;
            });
        dispatch({
            type: SET_CONTACT_DATA,
            payload: contactData
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

export const submitContact = (event, verb) => async(dispatch, getState) => {
    try {
        event.persist();
        event.target.disabled = true;
        dispatch({ type: SET_CONTACT_LOADING });

        // Setup the post data
        const { contacts: { contactData } } = getState();

        const role = contactData.user.roles.length ?
            contactData.user.roles[0] :
            null;
        const groups = contactData.associated_groups;

        // user, roles, groups, contact_type (user, user.roles, associated_groups, contact_contact_type)
        const postData = {
            ...contactData.contact,
            ...contactData.user,
            groups: groups,
            contact_type: contactData.contact_contact_type
        };

        if (role) {
            postData.role = role.id;
        }

        // Send it to the right place
        const url =
            verb === "edit" ?
                "/contacts/edit/" + contactData.contact.id :
                "/contacts/add";

        const response = await axios.post(url, postData);

        dispatch(handleResponse(response));

        if (verb === "add" && response.data && response.data.id) {
            // We are adding, so redirect to the edit page
            await dispatch({ type: REMOVE_CONTACT_LOADING });
            event.target.disabled = false;
            window.location = `/app/contacts/edit/${response.data.id}`;
            dispatch(setAlert("Contact Added", "success"));
        }

        if (response.data.hasOwnProperty("id")) {
            dispatch(setAlert("Contact Submitted", "success"));
        }
        await dispatch({ type: REMOVE_CONTACT_LOADING });
        event.target.disabled = false;
    }
    catch (error) {
    // Axios returning anything other than status 200 will also send us here
        dispatch(handleError(error));

        event.target.disabled = false;
        dispatch({ type: REMOVE_CONTACT_LOADING });
    }
};
